import { render, staticRenderFns } from "./ConfigSmtp.vue?vue&type=template&id=55015d56&scoped=true"
import script from "./ConfigSmtp.vue?vue&type=script&lang=js"
export * from "./ConfigSmtp.vue?vue&type=script&lang=js"
import style0 from "./ConfigSmtp.vue?vue&type=style&index=0&id=55015d56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55015d56",
  null
  
)

export default component.exports